import React from 'react'
import styled from 'styled-components'
import ContactBanner from '../components/sections/ContactBanner'
import ContactFormSection from '../components/sections/ContactFormSection'

export default function ContactPage() {
	return (
		<Block>
			<ContactBanner />
			<ContactFormSection />
		</Block>
	)
}

const Block = styled.div`
	margin-bottom: 200px;
`
